import { useContext, useMemo } from 'preact/hooks';
import { createContext } from 'preact';
import type { ComponentChildren } from 'preact';
import type { ExperienceFlattened } from '@thesavingsgroup/experience-configuration';

export interface QueryParamsProviderProps {
  children: ComponentChildren;
  search?: string;
}

const QueryParamsContext = createContext<ExperienceFlattened | null>(null);

export const QueryParamsProvider = ({
  children,
  search = window.location.search,
}: QueryParamsProviderProps) => {
  const queryParams = useMemo(() => {
    const params = new URLSearchParams(search);

    const queryParamsObject: ExperienceFlattened = {
      configurationCode: '',
      name: '',
      parentUrl: '',
      targetSelector: '',
      'rateCalculator.backgroundColor': undefined,
      'rateCalculator.creditTier': undefined,
      'rateCalculator.loanAmount': undefined,
      'rateCalculator.loanTerm': undefined,
      'rateCalculator.loanType': undefined,
      'rateCalculator.padding': undefined,
      'rateCalculator.primaryColor': undefined,
      'rateCalculator.secondaryColor': undefined,
      'rateCalculator.showResults': false,
    };

    for (const [key, value] of params.entries()) {
      if (value === 'true' || value === 'false') {
        queryParamsObject[key] = value === 'true';
      } else {
        queryParamsObject[key] = value;
      }
    }

    return queryParamsObject;
  }, [search]);

  return (
    <QueryParamsContext.Provider value={queryParams}>
      {children}
    </QueryParamsContext.Provider>
  );
};

export const useQueryParams = () => {
  return useContext(QueryParamsContext);
};
